import { render } from "./TrfPeriodoInput.vue?vue&type=template&id=70220b7f&scoped=true"
import script from "./TrfPeriodoInput.vue?vue&type=script&lang=js"
export * from "./TrfPeriodoInput.vue?vue&type=script&lang=js"

import "./TrfPeriodoInput.vue?vue&type=style&index=0&id=70220b7f&lang=scss&scoped=true"

import exportComponent from "/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70220b7f"],['__file',"src/components/Input/TrfPeriodoInput.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "70220b7f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('70220b7f', __exports__)) {
    console.log('reload')
    api.reload('70220b7f', __exports__)
  }
  
  module.hot.accept("./TrfPeriodoInput.vue?vue&type=template&id=70220b7f&scoped=true", () => {
    console.log('re-render')
    api.rerender('70220b7f', render)
  })

}


export default __exports__